/* eslint-disable no-nested-ternary */
import React, { useEffect, useCallback, useState } from "react";
import { toast } from "react-toastify";
import { API, get } from "../../../config.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faFolderPlus,
  faClock,
  faExclamationCircle,
  faXmarkCircle,
} from "@fortawesome/free-solid-svg-icons";
import { checkRole } from "../../common/Misc.js";
const roleType = localStorage.getItem("roleType");

export const getStatusIcon = (status, is_resolved) => {
  switch (status) {
    case "1":
      return is_resolved ? (
        <div className="support-status-resolved support-status-body">
          {" "}
          <FontAwesomeIcon icon={faCheckCircle} title="Resolved" />
          <span className="support-status-text">Resolved</span>
        </div>
      ) : (
        <div className="support-status-new support-status-body">
          {" "}
          <FontAwesomeIcon icon={faFolderPlus} title="New" />
          <span className="support-status-text">New</span>
        </div>
      );
    case "2":
      return is_resolved ? (
        <div className="support-status-resolved support-status-body">
          {" "}
          <FontAwesomeIcon icon={faCheckCircle} title="Resolved" />
          <span className="support-status-text">Resolved</span>
        </div>
      ) : (
        <div className="support-status-open support-status-body">
          {" "}
          <FontAwesomeIcon icon={faExclamationCircle} title="Open" />
          <span className="support-status-text">Open</span>
        </div>
      );
    case "3":
      return is_resolved ? (
        <div className="support-status-resolved support-status-body">
          {" "}
          <FontAwesomeIcon icon={faCheckCircle} title="Resolved" />
          <span className="support-status-text">Resolved</span>
        </div>
      ) : (
        <div className="support-status-in-progress support-status-body">
          {" "}
          <FontAwesomeIcon icon={faClock} title="Pending" />
          <span className="support-status-text">Pending</span>
        </div>
      );
    case "4":
      return (
        <div className="support-status-closed support-status-body">
          {" "}
          <FontAwesomeIcon icon={faXmarkCircle} title="Closed" />
          <span className="support-status-text">Closed</span>
        </div>
      );
    default:
      return null;
  }
};

export const getSupportDetail = async (id) => {
  try {
    const { data } = await get(
      checkRole(roleType)
        ? `${API.ADMIN_SUPPORT_TICKET}/${id}`
        : `${API.SUPPORT_TICKET}/${id}`
    );
    return data.data;
  } catch (e) {
    const { data } = e.response;
    if (data) {
      toast.error(data?.message);
      toast.error(
        data.errors && data.errors.myna_error && data.errors.myna_error[0]
      );
    }
    return null;
  }
};

export const useOfficeList = () => {
  const [officeList, setOfficeList] = useState([]);
  const [officeDataLoading, setOfficeDataLoading] = useState(false);
  const init = useCallback(async () => {
    try {
      setOfficeDataLoading(true);
      const { data } = await get(`${API.GET_OFFICE_LIST}?limit=-1`);
      setOfficeDataLoading(false);
      setOfficeList(data.data.data);
    } catch (e) {
      setOfficeList([]);
    }
  }, []);

  useEffect(() => {
    init();
  }, [init]);

  return {
    officeList,
    officeDataLoading,
  };
};

export const useRoleList = () => {
  const [roleList, setRoleList] = useState([]);
  const [roleDataLoading, setRoleDataLoading] = useState(false);
  const init = useCallback(async () => {
    try {
      setRoleDataLoading(true);
      const { data } = await get(`${API.GET_ROLE_LIST}?type=${roleType}`);
      setRoleDataLoading(false);
      setRoleList(data.data.data);
    } catch (e) {
      setRoleList([]);
    }
  }, []);

  useEffect(() => {
    init();
  }, [init]);

  return {
    roleList,
    roleDataLoading,
  };
};

export const phoneValidationRules = [
  {
    required: true,
    message: "Please enter Phone number",
  },
  {
    pattern: new RegExp(/\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{3})/),
    message: "Please enter only number",
  },
  {
    min: 9,
    message: "Minimum 9 digits are required in Phone number",
  },
  {
    max: 16,
    message: "Maximum 16 digits are allowed in Phone number",
  },
];
